import { Component, OnInit, ElementRef,ViewChild, Input} from '@angular/core';
import { Location, LocationStrategy, PathLocationStrategy } from '@angular/common';
import { Router } from '@angular/router';
import { AdminService } from '../../services/admin';
import { Employer } from '../../../model/model.employer';
import { Popup } from 'ng2-opd-popup';
import { Agent_Mef } from 'model/modal-cms/aget_mef';
import { Loggin } from '../../../model/loggin';
import { UserCMS } from 'model/modal-cms/user.cms';
declare var mdtoast: any;
var success_message = mdtoast('Opération effectuée avec succès.', { duration: 5000, init: true, type: mdtoast.SUCCESS });
var info_message = mdtoast('Opération non effectuée. Connexion échouée (Entre ROHI et TOMADY)', { duration: 5000, init: true, type: mdtoast.INFO });
var error_message = mdtoast('Ancien mot de passe incorrecte !!', { duration: 5000, init: true, type: mdtoast.ERROR });
var ERROR_ENREGISTREMENT = mdtoast('Confirmer votre mot de passe', { duration: 5000, init: true, type: mdtoast.ERROR });
 

@Component({
    selector: 'app-navbar',
    templateUrl: './navbar.component.html',
    styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit {
    private toggleButton: any;
    private sidebarVisible: boolean;
    @ViewChild('popup5') popup5: Popup;
     @ViewChild('popupEditProfilUser') popupEditProfilUser: Popup;
    agent_Mef : Agent_Mef;
    photo_user:any ="assets/img/cms/dr/user.png";
    nom_user:any = "Nom agent du MEF";
    prenom_user:any = "Prenom(s) agent";
    code:string="ABCDEFghojklm123456789";
    informationAgentDRHA:any;
    listeMedecin : Array<Employer>=new Array<Employer>();
    @Input() getMenuAdmin: boolean;
    @Input() getMenuUser: boolean;
    loginuserCMSActuel: any;
    mode_menu:number;
    mtpuserCMSActuel:any;
     loggin: Loggin = new Loggin();
     userCMS: UserCMS = new UserCMS();
    cinactuelUserCMS: any;
    nombre_message_actu: any;
    nombre_bc_actu : any;

    constructor(public location: Location, private element: ElementRef, private router: Router,  private adminService: AdminService, ) {
       // this.mtpuserCMSActuel = this.adminService.getMtpUseCMS();
     //  "CENTRE MEDICO SOCIAL DU MINISTERE"

       

       this.adminService.newCribSubect_login_user_cms.subscribe(
        data => {
            this.loginuserCMSActuel=data
            console.log("+++++++++++++++++++++++++++e"+this.loginuserCMSActuel);
            if(this.loginuserCMSActuel == "cms_daf" ){
                this.nombre_message_actu = ""; 
                    this.mode_menu =1;                   
            }else  if(this.loginuserCMSActuel == "com_daf"){
                   this.mode_menu =11;
                   this.adminService.newCribSubect_message_user.subscribe(
                    data => {
                        this.nombre_message_actu = "( " +data+ " )";           
                    }
                  );
               
            }else if(this.loginuserCMSActuel == "val_bc"){
                     this.mode_menu =11;  
                     this.adminService.newCribSubect_message_bc.subscribe(
                    data => {
                        this.nombre_bc_actu = "( " +data+ " )";           
                    }
                  ); 
             }else  {
                this.nombre_message_actu = ""; 
                this.nombre_bc_actu = ""; 
                this.mode_menu =11;             
                
             }
          
        }
      );

         //alert BC
       


     


     




        this.adminService.newCribSubect_mtp_user_cms.subscribe(
            data => {
                this.mtpuserCMSActuel=data            
            }
          );

        this.adminService.newCribSubect_Inscrit.subscribe(
            data => {
              console.log("Teste paste value in header Component AGENT :" + data);
              this.nom_user =  data
               console.log("this.agent_Mef transfere"+this.agent_Mef);
              
            }
          );

          this.adminService.newCribSubect2.subscribe(
            data => {
              //console.log(".............. hafa koa ........ :" + data);
              this.informationAgentDRHA = data;
            //   console.log(" .....................this.informationAgentDRHA...................."+ this.informationAgentDRHA);
              
            }
          );
             this.sidebarVisible = false;
    }


    

    ngOnInit() {
        const navbar: HTMLElement = this.element.nativeElement;
        this.toggleButton = navbar.getElementsByClassName('navbar-toggler')[0];
       this.nom_user= this.adminService.getConnectedEmployernom();
             
    }


    test(){
        this.adminService.getlisteWSDrh2(340909,this.code)
        .subscribe(data => {
          this.agent_Mef = data
          this.nom_user =  this.agent_Mef.agent_nom
         // this.adminService.setConnectedEmployer(this.agent_Mef);              
          console.log("data DRHA avy nalefa"+data);        
        }, err => {
          console.log(err);
        })

        // this.adminService.newCribSubect.subscribe(
        //     data => {
        //       console.log("Teste paste value in header Component AGENT :" + data);
        //       this.agent_Mef = data;
        //       this.nom_user =  this.agent_Mef.agent_nom
        //       console.log("this.agent_Mef transfere"+this.agent_Mef);              
        //     }
        //   );
    }

    sidebarOpen() {
        const toggleButton = this.toggleButton;
        const html = document.getElementsByTagName('html')[0];
        // console.log(html);
        // console.log(toggleButton, 'toggle');

        setTimeout(function () {
            toggleButton.classList.add('toggled');
        }, 500);
        html.classList.add('nav-open');

        this.sidebarVisible = true;
    };
    sidebarClose() {
        const html = document.getElementsByTagName('html')[0];
        // console.log(html);
        this.toggleButton.classList.remove('toggled');
        this.sidebarVisible = false;
        html.classList.remove('nav-open');
    };
    sidebarToggle() {
        // const toggleButton = this.toggleButton;
        // const body = document.getElementsByTagName('body')[0];
        if (this.sidebarVisible === false) {
            this.sidebarOpen();
        } else {
            this.sidebarClose();
        }
    };
    isHome() {
        var titlee = this.location.prepareExternalUrl(this.location.path());
        if (titlee.charAt(0) === '#') {
            titlee = titlee.slice(1);
        }
        if (titlee === '/home') {
            return true;
        }
        else {
            return false;
        }
    }
    isDocumentation() {
        var titlee = this.location.prepareExternalUrl(this.location.path());
        if (titlee.charAt(0) === '#') {
            titlee = titlee.slice(1);
        }
        if (titlee === '/documentation') {
            return true;
        }
        else {
            return false;
        }
    }

    open(lieu: any) {
        console.log(lieu);
        this.adminService.setlieu(lieu);
        this.router.navigate(['medecin']);
    }

    valide(p:any) {  
        console.log(p);     
        this.popup5.hide();        
        this.router.navigate(['evaluation/'+p]);
    }

    open1(){
        if(this.loginuserCMSActuel == "com_daf" || this.loginuserCMSActuel == "cms_daf"){
            this.router.navigate(['question']);
        }else{
            this.router.navigate(['questions']);
       
        }     
      
    }


     bc(){
        if(this.loginuserCMSActuel == "val_bc"){
            this.router.navigate(['list-bc']);
        }else{
            this.router.navigate(['bc']);       
        } 
      
    }
   

    open2() {
        this.popup5.options = {
          cancleBtnClass: "btn btn-danger",
          confirmBtnClass: "btn btn-success",
        color: "#0F7B79 ",
          showButtons: true,
          animationDuration: 1.5,
          header: "Evaluation en ligne",
          widthProsentage: 30,
          animation: "fadeInRight",
          confirmBtnContent: "Oui, evaluer",
          cancleBtnContent: "Fermer",
        }
    
        this.popup5.show(this.popup5.options);
        this.getListMedecin();
      }


      getListMedecin(){
        this.adminService.getMedecin("",0,0).subscribe(data=>{
            this.listeMedecin=data;
        },err=>{
    
        });
      }


      
logout() {
    let a= null;
    let b= null;      
    console.log("fafana ny cache")
    this.adminService.setUserloginUserCMS(a,b);
    this.adminService.setUserIscrit(a,b);
   //  this.router.navigate(['/login']);  
   this.router.navigate(['/index']);     
   
}



  onAnnulerProfilUser() {
    this.popupEditProfilUser.hide();
    this.loggin.mot_de_pass = null;
    this.loggin.nouveau_mot_de_pass = null;
    this.loggin.confirmation_mot_de_pass = null;
  }

  gererCompteAgent(){
      if(this.loginuserCMSActuel == "cms_daf"){
        this.router.navigate(['/admin-']);  
      }else{
        this.popupPorfilUsere();
      }
      
  }

   popupPorfilUsere() {
    this.popupEditProfilUser.options = {
      cancleBtnClass: "btn btn-default",
      confirmBtnClass: "btn btn-mbe-attack",
      color: "#0F7B79",
      animationDuration: 1,
      showButtons: false,
      header: "Gérer compte",
      widthProsentage: 45,
      animation: "fadeInRight",
      confirmBtnContent: "Enregistrer"
    }
    this.popupEditProfilUser.show(this.popupEditProfilUser.options);
  }



  onEregistrerProfilUser() {
    if (this.loggin.mot_de_pass != this.mtpuserCMSActuel) {
     error_message.show();
    } else {
      if (this.loggin.nouveau_mot_de_pass == this.loggin.confirmation_mot_de_pass) {      
        this.userCMS.password = this.loggin.nouveau_mot_de_pass
        this.userCMS.id_user =  this.cinactuelUserCMS
        console.log(this.userCMS);
        this.adminService.updateUser(this.userCMS,this.code)
          .subscribe(data => {
            console.log(data);
            this.onAnnulerProfilUser();
             success_message.show();
          }, err => {
            info_message.show();
          })
      } else {
         ERROR_ENREGISTREMENT.show();
     }
    }
}


  







}







